import { useIntl } from 'react-intl';
import React from 'react';
import { useTitleStore } from 'src/stores/useTitleStore';
import MoneyAccountsTable from 'src/features/moneyAccounts/components/tables/MoneyAccountsTable';
import { moneyAccountsMessages } from 'src/features/moneyAccounts/utils/messages';

const MoneyAccountsLayout = () => {
    const { setTitle, removeTitle } = useTitleStore();
    const { formatMessage } = useIntl();

    React.useEffect(() => {
        setTitle(formatMessage(moneyAccountsMessages.moneyAccounts));
        return removeTitle;
    }, [formatMessage, removeTitle, setTitle]);

    return <MoneyAccountsTable />;
};

export default MoneyAccountsLayout;
